import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import ImageUploader from '../ImageUploader';

function ToggleSwitch({ checked, onChange }) {
  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="toggle-track" />
      <span className="toggle-thumb" />
    </label>
  );
}

export default function GalleryComponentEditor({ item, onChange, websiteId }) {
  const [activeTab, setActiveTab] = useState('collection');

  const updateField = (field, val) => {
    onChange?.({ ...item, [field]: val });
  };

  const addImage = (img) => {
    updateField('images', [...(item.images || []), img]);
  };

  const updateImage = (imgIdx, field, val) => {
    const imgs = (item.images || []).map((im, j) => (j === imgIdx ? { ...im, [field]: val } : im));
    updateField('images', imgs);
  };

  const removeImage = (imgIdx) => {
    const imgs = (item.images || []).filter((_, j) => j !== imgIdx);
    updateField('images', imgs);
  };

  return (
    <div className="mt-3">
      <div className="profile-tabs mb-3">
        <div className="tabs-row">
          <button
            type="button"
            className={`tab-btn${activeTab === 'collection' ? ' active' : ''}`}
            onClick={() => setActiveTab('collection')}
          >
            Collection
          </button>
          <button
            type="button"
            className={`tab-btn${activeTab === 'properties' ? ' active' : ''}`}
            onClick={() => setActiveTab('properties')}
          >
            Settings
          </button>
        </div>
      </div>

      {activeTab === 'collection' && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
            <span className="component-item-field-label" style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--green)' }}>
              Images ({(item.images || []).length})
            </span>
            <ImageUploader
              websiteId={websiteId}
              onUploaded={(resp) => {
                const url = resp?.url || resp?.data?.url || resp?.file?.url || '';
                if (!url) return;
                addImage({ src: url, title: '' });
              }}
              label="Upload image"
            />
          </div>

          {(item.images || []).length === 0 && (
            <p className="muted-hint mb-0">No images added yet</p>
          )}

          <div className="comp-img-list">
            {(item.images || []).map((img, imgIdx) => (
              <div key={imgIdx} className="comp-img-row">
                <img src={img.src} alt={img.title || `img-${imgIdx}`} className="comp-img-thumb" />
                <Form.Control
                  type="text"
                  value={img.title || ''}
                  onChange={(e) => updateImage(imgIdx, 'title', e.target.value)}
                  placeholder="Image title (optional)"
                  size="sm"
                />
                <button
                  type="button"
                  className="comp-img-remove"
                  onClick={() => removeImage(imgIdx)}
                  title="Remove image"
                >×</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'properties' && (
        <div className="comp-settings">
          <div className="comp-setting-row">
            <span className="comp-setting-label">Autoplay</span>
            <ToggleSwitch
              checked={item.autoPlay}
              onChange={(e) => updateField('autoPlay', e.target.checked)}
            />
          </div>
          <div className="comp-setting-row">
            <span className="comp-setting-label">Navigation arrows</span>
            <ToggleSwitch
              checked={item.showNav}
              onChange={(e) => updateField('showNav', e.target.checked)}
            />
          </div>
          <div className="comp-setting-row">
            <span className="comp-setting-label">Full-screen button</span>
            <ToggleSwitch
              checked={item.showFullScreenButton}
              onChange={(e) => updateField('showFullScreenButton', e.target.checked)}
            />
          </div>
          <div className="comp-setting-row">
            <span className="comp-setting-label">Thumbnails strip</span>
            <ToggleSwitch
              checked={item.showThumbnails}
              onChange={(e) => updateField('showThumbnails', e.target.checked)}
            />
          </div>
          <div className="comp-setting-row">
            <span className="comp-setting-label">Image titles</span>
            <ToggleSwitch
              checked={item.showImageTitles}
              onChange={(e) => updateField('showImageTitles', e.target.checked)}
            />
          </div>
          <div className="comp-setting-row">
            <span className="comp-setting-label">Slide interval (seconds)</span>
            <Form.Control
              type="number"
              size="sm"
              className="comp-setting-num"
              value={item.slideIntervalSeconds}
              onChange={(e) => updateField('slideIntervalSeconds', Number(e.target.value))}
            />
          </div>
        </div>
      )}
    </div>
  );
}
